import { get, set } from 'lodash/fp';
import { useCallback } from 'react';

import { useBrandingContext } from '../../../../../../branding.context';

export const useDesignField = (valuePath: Array<string>) => {
  const { portalConfig, updatePortalConfig, defaultValues } =
    useBrandingContext();
  const defaultValue = get(valuePath, defaultValues);
  const value = get(valuePath, portalConfig) ?? defaultValue;

  const onChange = useCallback(
    (value: string | boolean | null) =>
      updatePortalConfig(set(valuePath, value)),
    [updatePortalConfig, valuePath]
  );

  return {
    value,
    onChange,
    defaultValue,
  };
};
